import { Landmark, Palette, Sparkles, Bike, BookOpen, MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const REASONS = [
    {
        icon: Landmark,
        title: "Heritage Museum",
        text: "A museum in Penang devoted to Indian heritage — curated rooms of rare artefacts, mud statues, tin toys and film memorabilia.",
    },
    {
        icon: Palette,
        title: "Indian Heritage Gallery",
        text: "An Indian heritage gallery in George Town presenting luminous Tanjore paintings, Pichwai and Pattachitra art and hand-painted murals.",
    },
    {
        icon: Sparkles,
        title: "Cultural Experience",
        text: "Heritage you can step inside — sari and traditional dress-up, hosted storytelling and the interactive Seeking & Learning Hall.",
    },
    {
        icon: Bike,
        title: "Vintage Collections",
        text: "Vintage scooters and two-wheelers, classic machines and everyday objects from another era — conserved with collector's care.",
    },
    {
        icon: BookOpen,
        title: "Historical Stories",
        text: "Every object has a story — from Penang's Indian history to Nagarathar traditions, told across seven immersive chapters.",
    },
    {
        icon: MapPin,
        title: "George Town Heritage",
        text: "Set within the UNESCO-listed streetscape of George Town, one of the most distinctive heritage attractions in Penang.",
    },
];

const WhyVisit = () => (
    <section id="why-visit" data-testid="why-visit-section" className="bg-heritage-cream py-24 md:py-36">
        <div className="mx-auto max-w-7xl px-5 md:px-10">
            <Reveal className="max-w-2xl">
                <Eyebrow>Why Visit IHCC</Eyebrow>
                <h2 className="mt-6 font-serif text-3xl font-medium leading-tight tracking-tight text-heritage-ink sm:text-4xl lg:text-5xl">
                    Six Reasons to Step <em className="text-heritage-terra">Inside</em>
                </h2>
            </Reveal>

            <div data-testid="why-visit-reasons-grid" className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {REASONS.map((r, i) => (
                    <Reveal key={r.title} delay={0.08 * (i % 3)}>
                        <article className="group h-full rounded-2xl border border-heritage-terra/12 bg-heritage-parchment p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-heritage-terra/30 hover:shadow-[0_24px_60px_-24px_rgba(140,42,12,0.35)]">
                            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-heritage-terra/10 text-heritage-terra transition-colors duration-500 group-hover:bg-heritage-terra group-hover:text-heritage-parchment">
                                <r.icon size={22} strokeWidth={1.6} />
                            </div>
                            <h3 className="mt-6 font-serif text-2xl font-semibold text-heritage-ink">
                                {r.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-heritage-ink/70">
                                {r.text}
                            </p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default WhyVisit;
